angular
    .module('festzelt-os.theme.festzelt-os', []);

// Components
require('./components/header/component');
require('./components/al-pagination/component');
require('./components/al-top-search/component');

// Directives
require('./directives/al-dropdown/al-dropdown-directive');

// Factories
require('./factories/pager');



// WEBPACK FOOTER //
// ./src/app/theme/festzelt-os/festzelt-os-module.js